export default __webpack_public_path__ + "static/media/darox-farm.6be123ff.png";